<!--
 * @created on 2018/11/13
 * @author LaiXinYu <laixinyualex@gmail.com>
-->

<template>
    <div class="img-upload-wrap">
        <div class="label">
            <div class="label-text">图片（选填）</div>
            <div class="img-num">{{ imageArray && imageArray.length ? imageArray.length : 0 }}/9
            </div>
        </div>
        <div class="img-showcase">
            <input type="file" class="needsclick" hidden ref="imgInput" accept="image/*">
            <!-- 没有上传时展示 -->
            <div class="img-list nothing" v-show="!imageArray || !imageArray.length">
                <div class="add-btn needsclick" @click="handleImgUpload"></div>
                <div class="tips">上传自拍、出游地点美图等，更容易约伴成功哦～</div>
            </div>

            <div class="img-list real" v-show="imageArray && imageArray.length">
                <div class="img-list-scroll-wrap">
                    <div class="img-item" v-for="(img,index) in imageArray" :key="img.src">
                        <div class="img-content">
                            <img :src="img.src">

                            <div class="label" v-if="img.status === 0">上传中</div>
                        </div>

                        <div class="del-btn" @click="handleRemoveImg(index)"></div>
                    </div>

                    <div class="add-btn needsclick" v-if="imageArray.length < 9" @click="handleImgUpload"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
@import "../../style/config";
@import "../../style/function";

.img-upload-wrap {
    padding: px2rem(20);
    background: #fff;
    margin-bottom: px2rem(10);

    .label {
        display: flex;
        color: #333;
        font-size: px2rem(32);

        .label-text {
            flex: 1;
        }

        .img-num {
            color: #999;
        }
    }
}

.img-showcase {
    display: flex;

    .img-list {
        padding-top: px2rem(22);

        &.nothing {
            display: flex;
            justify-content: center;
            align-items: center;
        }

        &.real {
            overflow-y: hidden;
            overflow-x: scroll;

            .img-list-scroll-wrap {
                white-space: nowrap;
            }
        }
    }

    .tips {
        flex: 1;
        position: relative;
        background: $btnColor;
        color: #fff;
        font-size: px2rem(28);
        border-radius: px2rem(10);
        padding: px2rem(14) px2rem(24);
        margin-left: px2rem(18);

        &:before {
            content: "";
            position: absolute;
            left: 0;
            top: 50%;
            transform: translate(-50%, -50%) rotate(45deg);
            width: px2rem(16);
            height: px2rem(16);
            background: $btnColor;
        }
    }

    .add-btn {
        display: inline-block;
        position: relative;
        width: px2rem(132);
        height: px2rem(132);
        border-radius: px2rem(6);
        border: px2rem(2) solid #e5e5e5;
        box-sizing: border-box;

        &:before,
        &:after {
            content: "";
            position: absolute;
            top: 50%;
            left: 50%;
            width: px2rem(68);
            height: px2rem(4);
            transform: translate(-50%, -50%);
            background: #e5e5e5;
        }

        &:after {
            transform: translate(-50%, -50%) rotate(90deg);
        }
    }

    .img-item {
        position: relative;
        display: inline-block;
        width: px2rem(132);
        height: px2rem(132);
        margin-right: px2rem(32);
        border-radius: px2rem(6);

        .img-content {
            position: relative;
            width: 100%;
            height: 100%;
            overflow: hidden;
        }

        img {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            min-width: 100%;
            max-width: 100%;
        }

        .label {
            position: absolute;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;
            font-size: px2rem(24);
            background: rgba(0, 0, 0, 0.4);
            bottom: 0;
            left: 0;
            width: px2rem(140);
            height: px2rem(44);
            z-index: 3;
        }

        .del-btn {
            position: absolute;
            top: 0;
            right: 0;
            transform: translate(50%, -50%);
            width: px2rem(32);
            height: px2rem(32);
            border-radius: 100%;
            background: rgba(0, 0, 0, 0.4);
            z-index: 3;

            &:before,
            &:after {
                content: "";
                top: 50%;
                left: 50%;
                position: absolute;
                width: px2rem(16);
                height: px2rem(2);
                background: #fff;
            }

            &:before {
                transform: translate(-50%, -50%) rotate(45deg);
            }

            &:after {
                transform: translate(-50%, -50%) rotate(-45deg);
            }
        }
    }
}
</style>

<script>
import { uploadImg } from "../../api/common";

import { imageListConvert } from "../../lib/imgConvert";

export default {
    name: "ImgUpload",
    props: {
        images: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            imageArray: []
        };
    },
    created() {
        let newImgArr = [];

        this.images.forEach(img => {
            newImgArr.push({
                src: img,
                status: 1
            });
        });

        this.imageArray = newImgArr;
    },
    methods: {
        async handleImgUpload() {
            const { target } = await this.chooseImg();

            if (!target.value) return;

            if (!/jpg|jpeg|gif|png/.test(target.value.toLowerCase())) {
                this.$toast.open({
                    msg: "暂不支持该图片格式，请重新选择"
                });

                return;
            }

            console.log("ffs");

            const len = this.imageArray.length;
            if (!target) {
                return;
            }
            const { base64Data: content, fileType } = await this.compressionImg(
                target
            );

            this.imageArray.push({
                src: `data:image/${fileType};base64,${content}`,
                status: 0
            });

            this.$emit("change", {
                images: this.imageArray
            });

            this.uploadSaveImg(content, fileType, len);
        },

        /**
         * 选择图片
         * @returns {Promise<any>}
         */
        chooseImg() {
            return new Promise(resolve => {
                const imgInput = this.$refs.imgInput;

                imgInput.click();

                imgInput.onchange = resolve;
            });
        },

        /**
         * 压缩图片
         * @param target
         * @returns {Promise<any>}
         */
        compressionImg(target) {
            return new Promise(resolve => {
                imageListConvert(target.files, resolve);
            });
        },

        /**
         * 上传图片
         * @param content
         * @param fileType
         * @returns {Promise<any>}
         */
        uploadSaveImg(content, fileType, index) {
            return new Promise(async resolve => {
                const { msg, code, data } = await uploadImg({
                    content,
                    fileType
                });

                if (code === 200) {
                    this.$set(this.imageArray, index, {
                        src: data.url,
                        status: 1
                    });

                    this.$emit("change", {
                        images: this.imageArray
                    });

                    resolve();
                } else {
                    this.$toast.open({ msg });
                }
            });
        },

        /**
         * 删除图片
         * @param index
         */
        handleRemoveImg(index) {
            this.imageArray.splice(index, 1);

            this.$emit("change", {
                images: this.imageArray
            });
        }
    }
};
</script>
